export enum SessionStatus {
    Nominated = 0,
    Accepted = 1,
    AcceptQueue = 2,
    DeclineQueue =3,
    Declined= 4,
    Withdrawn = 5
}
  